import { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Form, Input, InputGroupText } from 'reactstrap';
import { useTranslator, Loader, useAppContext } from '@front-activerse/common-components';
import Layout from '../../../Layout/Layout';
import TitleBar from '../../../Layout/TitleBar';
import { useOutletContext } from 'react-router-dom';

const DayPlanChangeDayContainer = ({
  loadDayPlanDayReplacements,
  renderOriginalDay,
  replaceDay,
  children,
}) => {
  const { t } = useTranslator();
  const { trackFirebaseEvent } = useOutletContext();

  const {
    images: { searchIcon, noSearchResultsIcon, searchButton },
  } = useAppContext();

  const [useSearchResult, setUseSearchResult] = useState(false);
  const [search, setSearch] = useState('');
  const [preload, setPreload] = useState(false);
  const [replacements, setReplacements] = useState([]);
  const [original, setOriginal] = useState(null);
  const [dietSetId, setDietSetId] = useState(0);

  useEffect(() => {
    loadDayReplacements(search);
    trackFirebaseEvent('screen_view', {
      firebase_screen: 'Change_dayplan',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    loadDayReplacements(search);

    trackFirebaseEvent('user_action', {
      action: 'search_ingredient',
      location: 'Change_dayplan',
      search_content: search,
    });
  };

  const handleChange = (event) => {
    setSearch(event.target.value);
  };

  const loadDayReplacements = async (search) => {
    setPreload(true);
    const result = await loadDayPlanDayReplacements.load(search);

    setReplacements(result.data.me.diet.set.replacements);
    setOriginal(result.data.me.diet.set.original);
    setDietSetId(result.data.me.diet.set.dietSetId);

    setPreload(false);

    if (search) {
      setUseSearchResult(true);
    }
  };

  return (
    <Layout>
      <TitleBar level={2}>{t('mealPlan.changeMenu.navbarTitle')}</TitleBar>

      <div className="page-template-meal-plan">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="search-container">
                  <Form onSubmit={handleSubmit}>
                    <div className="input-group-with-addon start">
                      <InputGroupText>
                        <img src={searchIcon} alt="search" />
                      </InputGroupText>
                      <Input
                        name="search"
                        type="search"
                        enterkeyhint="search"
                        value={search}
                        onChange={handleChange}
                        placeholder={t('meal.search.inputPlaceholder')}
                      />
                      <Button type="submit" color="primary" size="sm" className="ms-2 px-m">
                        <img src={searchButton} alt="search" />
                      </Button>
                    </div>
                  </Form>
                </div>

                <div className="search-result-container">
                  <h2 className="title-medium semi-bold mb-m">
                    {useSearchResult
                      ? t('meal.searchResults.title')
                      : t('meal.recommendations.title')}
                  </h2>

                  {replacements.length > 0 ? (
                    <>
                      {original.dietSetId !== dietSetId ? (
                        <>{renderOriginalDay(original, search, replaceDay)}</>
                      ) : (
                        ''
                      )}
                      <>{children(replacements, search, replaceDay)}</>
                    </>
                  ) : (
                    search && (
                      <div className="text-center">
                        <img
                          src={noSearchResultsIcon}
                          width={64}
                          height={64}
                          className="mb-m"
                          alt=""
                        />
                        <p className="text-text-variant-color mb-m">
                          {t('meal.searchResults.noResultsContent')}
                        </p>
                        <p className="text-text-variant-color">
                          {t('meal.searchResults.noResultsAdditionalContent')}
                        </p>
                      </div>
                    )
                  )}

                  {preload ? <Loader /> : ''}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default DayPlanChangeDayContainer;
